import { Link, useLoaderData } from 'react-router-dom';
import { Button, Table } from 'antd';
import { useTranslation } from 'react-i18next';

import type { MapCategoriesLoaderType } from './queries';
import type { IMapCategory } from './types';

import { useMapCategoriesQuery } from './queries';
import { usePagination } from '@/hooks/usePagination';
import { useColumns } from './useColumns';
import { routes } from '@/app/router/routes';

import { PageHeader } from '@/ui/PageHeader';

export const MapCategories = () => {
  const { t } = useTranslation();
  const initialData = useLoaderData() as MapCategoriesLoaderType;
  const { data: mapCategories, isLoading } = useMapCategoriesQuery(initialData);

  return (
    <>
      <PageHeader
        title={t('mapCategories.title')}
        description={t('mapCategories.description')}
        extra={
          <Link to={routes.mapCategoryCreate()}>
            <Button type='primary'>{t('mapCategories.createButtonText')}</Button>
          </Link>
        }
      />
      <Table<IMapCategory>
        rowKey='id'
        dataSource={mapCategories.data ?? []}
        loading={isLoading}
        columns={useColumns()}
        pagination={usePagination(mapCategories.total, mapCategories.per_page)}
        scroll={{ x: 'max-content' }}
      />
    </>
  );
};
